
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { formatDateWithTime, formatBool } from "@/utils";
import { RereceiveBarcodeOrderRequest, RereceiveItem } from "@/models/api/barcodeSystem/barcodeOrders/rereceive";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";

const barcodeSystemModule = getModule(BarcodeSystemModule);

@Component
export default class BarcodeOrderRereceiving extends Vue {
  @Prop({ default: false })
  loading: boolean;

  @Prop({ default: null })
  rereceiveBarcodeOrderRequest: RereceiveBarcodeOrderRequest;

  @Prop({default: null})
  validationMessages: string[];

  get rereceiveItems(): Array<RereceiveItem> {
    return this.rereceiveBarcodeOrderRequest ? this.rereceiveBarcodeOrderRequest.orderItems : [];
  }

  get statusOptions() : Array<any> {
    return this.rereceiveBarcodeOrderRequest && this.rereceiveBarcodeOrderRequest.orderItemStatuses ? 
      this.rereceiveBarcodeOrderRequest.orderItemStatuses.map(x => ({ label: x.description, value: x.code })) :
      [];
  }

  get damageCodeOptions() : Array<any> {
    return barcodeSystemModule.damageCodes ?
      barcodeSystemModule.damageCodes.map(x => ({ label: x.description, value: x.code })) :
      [];
  }


  get crn(): string {
    return this.rereceiveBarcodeOrderRequest
      ? this.rereceiveBarcodeOrderRequest.crn
      : ""; 
  }

  get companyName(): string {
    return this.rereceiveBarcodeOrderRequest
      ? this.rereceiveBarcodeOrderRequest.companyName
      : ""; 
  }

  set companyName(val: string){
  }

  get displayBillToCompanyId(): string {
    return this.rereceiveBarcodeOrderRequest
      ? this.rereceiveBarcodeOrderRequest.displayBillToCompanyId
      : "";  
  }

  set displayBillToCompanyId(val: string){
  }

  get orderNumber(): string {
    return this.rereceiveBarcodeOrderRequest
      ? this.rereceiveBarcodeOrderRequest.orderNumber
      : ""; 
  }

  set orderNumber(val: string){
  }  
  
  get deliveryType(): string {
    return this.rereceiveBarcodeOrderRequest
      ? this.rereceiveBarcodeOrderRequest.deliveryType
      : ""; 
  }

  set deliveryType(val: string){
  }

  get status(): string {
    return this.rereceiveBarcodeOrderRequest
      ? this.rereceiveBarcodeOrderRequest.status
      : "";  
  }

  set status(val: string){
  }

  get statusDescription(): string {
    return this.rereceiveBarcodeOrderRequest
      ? this.rereceiveBarcodeOrderRequest.statusDescription
      : "";  
  }

  set statusDescription(val: string){
  }

  get facilityCode(): string {
    return this.rereceiveBarcodeOrderRequest
      ? this.rereceiveBarcodeOrderRequest.facilityCode
      : ""; 
  }

  set facilityCode(val: string){
  }

  get orderItemCount() : number
  {
    return this.rereceiveBarcodeOrderRequest && this.rereceiveBarcodeOrderRequest.orderItems
      ? this.rereceiveBarcodeOrderRequest.orderItems.length
      : 0;
  }

  get loadedDateTimeFormatted(): string{
    return this.rereceiveBarcodeOrderRequest
      ? formatDateWithTime(this.rereceiveBarcodeOrderRequest.loadedDate)
      : "";
  }

  set loadedDateTimeFormatted(val: string){
  }

  get deliveredDateTimeFormatted(): string{
    return this.rereceiveBarcodeOrderRequest
      ? formatDateWithTime(this.rereceiveBarcodeOrderRequest.deliveredDate)
      : "";
  }

  set deliveredDateTimeFormatted(val: string){
  }

  itemIsShort(item) : boolean
  {
    return item.status == 'M';
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val) {
    return formatDateWithTime(val)
  }

  formatBool(val) {
    return formatBool(val);
  }

  onDoubleClicked(data) {
  }

  handleDamagedChanged(data) {
    if(data.damaged)
    {
      data.quantityDamaged = data.quantity;
    }
    else
    {
      data.quantityDamaged = 0;
      data.damageCode = null;
    }
  }

  handleStatusChanged(data) {
    if(this.itemIsShort(data))
    {
      data.quantityReceived = 0;
    }
    else
    {
      data.quantityReceived = data.quantity;
    }
  }

}
